module.exports = __webpack_public_path__ + "static/media/ipo6.d1165c10.png";